import { getFormattedDate } from 'src/helpers/dateTime';
import { TextCell } from '../../../../components/tables/helperCells';
import { getActionColumn } from '../../../../components/tables/helperColumns';
import { t } from '../../../../i18n';
import { IGridAction, ILegalEntityRecord } from './actions.types';

interface IGetColumnsArgs {
  onEdit: (id: string) => void;
}

interface IPopoverAction extends IGridAction {
  name: string;
  onActionClick: () => void;
}

const buildPopoverActions = (record: ILegalEntityRecord, onEdit: (id: string) => void): IPopoverAction[] => {
  return (record.actions ?? []).map(action => ({
    ...action,
    name: t(`dash.admin.legalEntities.actions.${action.key}`),
    onActionClick: () => onEdit(record.id),
  }));
};

export function getColumns({ onEdit }: IGetColumnsArgs) {
  const notAvailable = t('dash.common.aliases.n/a');

  return [
    {
      title: t('dash.admin.legalEntities.columns.name_title'),
      key: 'name',
      width: '22%',
      sorter: true,
      truncated: true,
      getContentLength: (record: ILegalEntityRecord) => record.name?.length || 0,
      render: (record: ILegalEntityRecord, url?: string) => TextCell(record.name || notAvailable, url),
    },
    {
      title: t('dash.admin.legalEntities.columns.address_title'),
      key: 'address',
      width: '26%',
      render: (record: ILegalEntityRecord) => TextCell(record.address || notAvailable),
    },
    {
      title: t('dash.admin.legalEntities.columns.tax_registration_number_title'),
      key: 'tax_registration_number',
      width: '18%',
      render: (record: ILegalEntityRecord) => TextCell(record.tax_registration_number || notAvailable),
    },
    {
      title: t('dash.admin.legalEntities.columns.status'),
      key: 'status',
      width: '12%',
      render: (record: ILegalEntityRecord) => TextCell(record?.status?.name || notAvailable),
    },
    {
      title: t('dash.admin.legalEntities.columns.created_at_title'),
      key: 'created_at',
      width: '18%',
      sorter: true,
      render: (record: ILegalEntityRecord) =>
        TextCell(getFormattedDate({ date: record.created_at, formatKey: 'date_numeric_long' }) || notAvailable),
    },
    getActionColumn((record: ILegalEntityRecord) => buildPopoverActions(record, onEdit)),
  ];
}
